import artikel from './artikel';

export default {

  artikel,
};
